export default __webpack_public_path__ + "static/media/Tunic of Tranquility.dcef1370.jpg";